<template>
  <v-ons-page>

    <div v-show="initInfos != -2" class="content">

      <app-pull-hook :disabled="isSync" @call-api="$emit('call-api', $event)"></app-pull-hook>

      <div v-if="! user.cultures.length" class="content--perfhome content--perfhome__empty">
        <header>
          <img :src="$getBadgeAsset(nbFeuille)">
        </header>
        <section>
          <p>
            Ajoutez toutes vos cultures pour gérer votre récolte {{ campagne }}.
          </p>
        </section>
        <footer>
          <v-ons-button modifier="large--cta perflarge" @click="showCultureListe(true)">
            Ajouter mes cultures
          </v-ons-button>
        </footer>
      </div>

      <div v-else class="content--perfhome">
        <v-ons-list modifier="noborder perflist">

          <template v-for="culture in culturesList">

            <v-ons-list-item :key="culture.index" modifier="perfcult chevron" tappable @click="showCulture(culture.index)">

              <div class="left">
                <span class="list-item__thumbnail"
                      :style="{'background-image': $getCultAsset(culture.refCulture, culture.refDestination, 'icon')}" />
              </div>

              <div class="center">
                <span class="list-item__title">
                  {{ culture.label }}
                  <img v-if="culture.isBio" src="../assets/imgs/bio_carre@2x.png">
                </span>
                <span v-if="culture.surface === 0" class="list-item__subtitle">
                  0 ha
                </span>
                <span v-else class="list-item__subtitle">
                  {{ culture.surface == undefined || culture.surface === '' ? '__' : culture.surface.toLocaleString('fr', { maximumFractionDigits: 2 }) }} ha
                  •
                  {{ culture.rendement == undefined || culture.rendement === '' ? '__' : (culture.rendement*10).toLocaleString('fr', { maximumFractionDigits: 1 }) }} q/ha
                </span>
              </div>

            </v-ons-list-item>

          </template>

          <v-ons-list-item modifier="perfbutton">
            <v-ons-button modifier="quiet" @click="showCultureListe(false)">
              Ajouter une culture
            </v-ons-button>
          </v-ons-list-item>

        </v-ons-list>

      </div>

    </div>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppPullHook from '../partials/PullHook.vue';

import AppCultureListe from './CultureListe.vue';
import AppCultureTonne from './CultureTonne.vue';
import AppApportListe from './ApportListe.vue';
import AppCultureFiche from './CultureFiche.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppPullHook },
  props: ['pageStack', 'initInfos'],
  data() {
    return {
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    clientConnect() {
      return this.state.client;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    isSync() {
      return this.state.isSync;
    },
    referentiel() {
      return this.data.referentiel;
    },
    culturesList() {
      var list = [];
      for (let indexCult = 0; indexCult < this.user.cultures.length; indexCult++) {
        const cult = this.user.cultures[indexCult];
        const cultItem = {
          refCulture: cult.ref_culture,
          refDestination: cult.ref_destination,
          label: this.getCultLabel(cult.ref_culture, cult.ref_destination),
          surface: cult.surface,
          rendement: cult.rendement,
          isBio: cult.is_bio,
          index: indexCult,
        };
        if(cultItem.surface < 0.0001){
          cultItem.surface = '';
          cultItem.rendement = '';
        } else if(cultItem.rendement < 0.0001) {
          cultItem.rendement = 0;
        }
        if(this.clientConnect.id){
          var clientConnectInfos = this.getClientConnectInfos(this.clientConnect.id, this.user.ventes, cult.ref_culture, cult.ref_destination);
          cultItem.surface = clientConnectInfos.surface;
          cultItem.rendement = clientConnectInfos.rendement;
        }
        list.push(cultItem);
      }
      this.sortCultList(list);
      return list;
    }
  },
  watch: {
    initInfos(value) {
      if(value == -1){
        this.showCultureListe(true);
      }
    }
  },
  methods: {
    showCultureListe(isAssolement){
      this.pageStack.push({
        extends: AppCultureListe,
        data() {
          return {
            isAssolement: isAssolement
          }
        },
        onsNavigatorOptions: {
          animation: 'lift'
        }
      });
    },
    showCulture(indexCult) {
      var cult = this.user.cultures[indexCult];
      if(this.clientConnect.id){
        var clientId = this.clientConnect.id;
        this.pageStack.push({
          extends: AppCultureTonne,
          data() {
            return {
              refCulture: cult.ref_culture,
              refDestination: cult.ref_destination,
              client: clientId
            }
          }
        });
      } else {
        var isApport = false;
        var negoce = this.getNegoceAcces(this.data.negoce.list);
        for (let i = 0; i < negoce.length; i++) {
          var negoceItem = negoce[i];
          if(negoceItem.apport
          && negoceItem.apport.list[this.campagne]
          && negoceItem.apport.list[this.campagne][cult.ref_culture]
          && negoceItem.apport.list[this.campagne][cult.ref_culture][cult.ref_destination]){
            isApport = true;
            break;
          }
        }
        if(isApport){
          this.pageStack.push({
            extends: AppApportListe,
            data() {
              return {
                refCulture: cult.ref_culture,
                refDestination: cult.ref_destination
              }
            }
          });
        } else {
          this.pageStack.push({
            extends: AppCultureFiche,
            data() {
              return {
                indexCulture: indexCult
              }
            }
          });
        }
      }
    }
  },
  created() {
    if(this.initInfos){
      if(this.initInfos == -1){
        this.showCultureListe(true);
      } else {
        var indexCult = parseInt(this.initInfos) - 1;
        if (this.user.cultures[indexCult]) {
          this.showCulture(indexCult);
        }
      }
    }
  }
}
</script>

<style>
.list-item--perfcult .list-item__expandable-content {
  padding-top: 0;
}
</style>